import React from 'react';
import GaugeChart from 'react-gauge-chart';

const GaugeChartComponent = () => {
  // Value should be between 0 and 1
  const value = 0.5; // Example value (50%)

  return (
    <div className='card p-1'>
      <h6 className='m-0 bold pb-4 p-2'>Score Rating</h6>
      <GaugeChart 
        id="gauge-chart" 
        nrOfLevels={20} 
        percent={value} 
        arcsLength={[0.3, 0.3, 0.3, .3]} // Adjust lengths of sections
        colors={['#e2506b', '#702ec2', '#4870f2', '#55b784']} // Color for each section
        arcPadding={0.02}  
        textColor="transparent" 
        cornerRadius={3} 
        style={{ height: '100%' }}
      />
      <div className='gauge-chart-itm-container'>
        <div className='c-g-chart'>
          <div className='c-g-color bg-red'></div>
          <div>Bad</div>
        </div>
        <div className='c-g-chart'>
          <div className='c-g-color bg-purple'></div>
          <div>Neutral</div>
        </div>
        <div className='c-g-chart'>
          <div className='c-g-color bg-blue'></div>
          <div>Good</div>
        </div>
        <div className='c-g-chart'>
          <div className='c-g-color bg-green'></div>
          <div>Very Good</div>
        </div>
      </div>
    </div> 
  );
};

export default GaugeChartComponent;
